import { render, staticRenderFns } from "./exam-details.vue?vue&type=template&id=41a608de&scoped=true"
import script from "./exam-details.vue?vue&type=script&lang=js"
export * from "./exam-details.vue?vue&type=script&lang=js"
import style0 from "./exam-details.vue?vue&type=style&index=0&id=41a608de&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a608de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41a608de')) {
      api.createRecord('41a608de', component.options)
    } else {
      api.reload('41a608de', component.options)
    }
    module.hot.accept("./exam-details.vue?vue&type=template&id=41a608de&scoped=true", function () {
      api.rerender('41a608de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/research/exam-details.vue"
export default component.exports